import { render, staticRenderFns } from "./StatesHistory.vue?vue&type=template&id=4b91194e&scoped=true&lang=pug"
import script from "./StatesHistory.vue?vue&type=script&lang=js"
export * from "./StatesHistory.vue?vue&type=script&lang=js"
import style0 from "./StatesHistory.vue?vue&type=style&index=0&id=4b91194e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b91194e",
  null
  
)

export default component.exports